import { ProfileName } from "./ProfileName";

export default ProfileName;
